export class WebhookV1StandardPayloadClassificationJobRejectedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "classificationJobRejected",
            "baseName": "classificationJobRejected",
            "type": "WebhookV1ClassificationJobRejectedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadClassificationJobRejectedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
